<template>
    <div>
        <b-link title="Ajouter un commentaire" @click="openAddModal">
            <span  class="small text-secondary">
                <i class="fas fa-fw fa-plus"></i>
            </span>
        </b-link>
        <b-link title="Afficher les commentaires" @click="openHistoryModal">
            <span  class="font-italic">
                {{ lastSpecificComment }}
            </span>
        </b-link>

        <b-modal
            :id="'comments-modal-id' + client.id"
            :key="'comments-modal-key' + client.id"
            :title="modalTitle"
            hide-footer
            no-close-on-backdrop
            centered
            size="lg"
        >
            <div v-if="showComments">
                <loading v-if="loading"/>
                <div v-if="!loading">
                <div v-if="hasComments">
                    <comment-handler
                        v-for="comment in yearComments"
                        :key="'ch' + comment.id"
                        :comment="comment"
                        @update="$emit('update')"
                    />
                </div>
                <div v-else>
                    <b-card
                        bg-variant="light"
                        no-body
                        class="text-dark p-2 mb-3 shadow-sm"
                    >
                        <p class="comment-description">
                            Aucun commentaire n'a été rédigé sur ce tiers
                        </p>
                    </b-card>
                </div>
                </div>
                <b-button variant="success" size="sm" @click="hideComments">
                    <i class="fas fa-fw fa-plus"/> Ajouter un commentaire
                </b-button>
            </div>
            <div v-else>
                <b-form-textarea
                    id="textarea"
                    v-model="form.description"
                    size="sm"
                    rows="3"
                    max-rows="6"
                    class="mb-2"/>
                <b-button v-if="hasComments" variant="secondary" size="sm" @click="hideForm">
                    <i class="fas fa-fw fa-arrow-alt-left"/> Retour aux
                    commentaires
                </b-button>
                <b-button variant="success" size="sm" @click="storeComment">
                    <i class="fas fa-fw fa-save"/> Enregistrer
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import loading from '../../../common/components/loading'
import CommentHandler from './CommentHandler'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'CommentsBlock',

    components: {
        loading,
        CommentHandler
    },

    mixins: [DataUpdater],

    props: {
        client: {
            type: Object,
            required: true
        },
        type: ''
    },

    data() {
        return {
            allComments: [],
            loading: true,
            showComments: null,
            form: {},
            modalTitle:null
        }
    },

    methods: {
        async openAddModal(){
            this.showComments = false
            this.modalTitle='Nouveau commentaire ' + this.client.name
            await this.openModal()
        },

        async openHistoryModal(){
            this.showComments = true
            this.modalTitle='Commentaires ' + this.client.name
            await this.openModal()
        },

        async openModal() {
            this.$bvModal.show(`comments-modal-id${this.client.id}`)
            await this.getComments()
        },

        async getComments() {
            try {
                this.loading = true
                const response = await axios.get(
                    `/clients/${this.client.id}/history`
                )
                this.allComments = response.data.data
                this.loading = false
            } catch (error) {
                console.log(error)
            }
        },

        async storeComment() {
            console.log('storing')
            try {
                this.form.client_id = this.client.id
                this.form.type = this.type
                this.form.display_year = this.year
                await axios.post('/clientEvents/event', this.form)
                await this.getComments()
                this.$emit('update')
                this.$emit('update-table')
                this.hideForm()
            } catch (error) {
                console.log(error)
            }
        },

        hideComments() {
            this.showComments = false
        },

        hideForm() {
            this.showComments = true
        }
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year
        }),

        specificComments() {
            return this.client.events === undefined
                ? null
                : this.client.events.filter(
                    (item) =>
                        item.assigned_to === null &&
                        item.type === this.type &&
                        item.display_year === this.year
                )
        },

        hasSpecificComments() {
            return this.specificComments === null
                ? false
                : this.specificComments.length > 0
        },

        lastSpecificComment() {
            return this.hasSpecificComments
                ? this.specificComments.slice(-1)[0].description
                : ''
        },

        yearComments() {
            return this.allComments.filter(
                (item) =>
                    item.display_year === this.year &&
                    item.type.code === this.type
            )
        },

        hasComments() {
            return this.yearComments.length > 0
        },

        lastCommentDisplay() {
            const maxLength = 15
            return this.lastComment.length > maxLength
                ? `${this.lastComment.substring(0, maxLength)}...`
                : this.lastComment
        },

        iconColor() {
            return this.hasComments ? 'text-secondary' : 'text-success'
        },

        title() {
            return this.hasComments
                ? 'Afficher les commentaires'
                : 'Ajouter un commentaire'
        }
    }
}
</script>

<style scoped>
.comments-container {
    background-color: white !important;
    padding: 15px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 650px;
}

.comment-description {
    margin-bottom: 0;
}

.comment-created {
    font-size: 11px;
    margin-bottom: 0;
    font-style: italic;
}
</style>
